import { useEffect } from "react";
import "whatwg-fetch";
import classNames from "classnames";
import { UPLOAD_STATUS_COMPLETED, useDirectFileUpload } from "./useDirectFileUpload";

const UploaderFileTransfer = props => {
  const { file, attachmentToken, onUploadStart, onUploadComplete, onUploadError } = props;

  const { upload, uploadStatus, uploadProgress } = useDirectFileUpload({
    file,
    attachmentToken,
    onUploadStart,
    onUploadComplete,
    onUploadError
  });

  const isUploadComplete = uploadStatus === UPLOAD_STATUS_COMPLETED;
  const className = classNames(["progress", props.className]);

  const progressBarClassName = classNames({
    "progress-bar": true,
    "bg-success": isUploadComplete
  });

  const width = uploadProgress.toString() + "%";

  // When the component is mounted, start the upload process.
  // The function handles internally whether the file is already uploaded or not.
  //
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => upload(), []);

  // Show progress bar
  return (
    <div className={className}>
      <div
        className={progressBarClassName}
        role="progressbar"
        style={{ width }}
        aria-valuenow={uploadProgress}
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
  );
};

export default UploaderFileTransfer;
